import axios from "axios";
import {Button, Modal} from "reactstrap";
import {useTranslation} from "react-i18next";

const InfoModal = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <Modal
            className="modal-dialog-centered"
            isOpen={props.isOpen}
        >
            <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                    {props.modalTitle}
                </h5>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => props.onRequestClose()}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                {
                    props.body()
                }
            </div>
            <div className="modal-footer">
                <Button color="primary" type="button" onClick={() => props.onRequestClose()}>
                    {t('Close')}
                </Button>
            </div>
        </Modal>
    )
}

export default InfoModal


